import type { AppRoute } from './routes';

export function renderShell(root: HTMLElement, route: AppRoute): HTMLElement {
  root.replaceChildren();

  const shell = document.createElement('div');
  shell.className = 'app-shell';
  shell.innerHTML = `
    <button class="skip-link" type="button">跳到主要内容</button>
    <header class="brand-bar"><a href="#" aria-label="两小只首页">两小只·生活小票</a></header>
    <main id="page" tabindex="-1" data-route="${route.name}"></main>
    <nav class="bottom-nav" aria-label="主要导航">
      <a href="#">首页</a>
      <a href="#tickets">单据</a>
      <a href="#settings">我们</a>
    </nav>
  `;
  root.append(shell);
  shell.querySelector<HTMLButtonElement>('.skip-link')?.addEventListener('click', () => {
    shell.querySelector<HTMLElement>('#page')?.focus({ preventScroll: false });
  });

  return shell;
}
